import React from 'react';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import { IconButton, Tooltip } from '@mui/material';
import SimCardDownloadTwoToneIcon from '@mui/icons-material/SimCardDownloadTwoTone';
import { useTranslation } from "react-i18next";

const ExcelExport = ({ data, fileName }) => {
    const { t } = useTranslation();

  const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(kanbanToExcell(data));
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([excelBuffer], {type: 'application/octet-stream'});
    saveAs(blob, `${fileName}.xlsx`);
  };    

  const kanbanToExcell = (kanban) => {
    var data = [];
    for(var i=kanban.columns.length-1; i>=0; i--) {
        data = data.concat(columnToExcell(kanban.columns[i]));
    }
    return data;
}

const columnToExcell = (column) => {
    var results = [];
    for(var i = 0; i<column.cards.length; i++) {
        var item = {
            stage: t("campaign.columns." + (column.title == "" ? "rejected" : column.title))
        };
        results.push(cardToExcell(item, column.cards[i]));
    };
    return results;
}

const cardToExcell = (item, card) => {
    item["fullName"] = card.fullName;
    item["location"] = card.location;
    item["phone"] = card.phone;
    item["email"] = card.email;
    item["rating"] = ratingToExcell(card.rating);

    item = formToExcell(item, card.form);
    item = commentsToExcell(item, card.comments);
    return item;
}

const ratingToExcell = (rating) => {
    switch(rating) {
        case 0:
            return "A";
        case 1: 
            return "B";
        case 2: 
            return "C";
        default: 
            return "-"
    }
}

const formToExcell = (item, form) => {
    for(var i = 0; i<form.segments.length; i++) {
        item = segmentToExcell(item, form.segments[i]);
    }
    return item;
}

const segmentToExcell = (item, segment) => {
    item[segment.question] = answersToExcell(segment.answers);
    return item;
}

const answersToExcell = (answers) => {
    
    var answer = "";
    for (var i=0; i<answers.length; i++) {
        if(answers[i].selected) {
            answer = answer + answers[i].answer + ", ";
        }
    }
    if (answer.substring(answer.length-2) == ", ")
    {
        answer = answer.substring(0, answer.length-2);
    }
    return answer;
}

const commentsToExcell = (item, comments) => {
    for(var i = 0; i<comments.length; i++) {
        item[("comment" + i)] = comments[i].content;
    }
    return item;
}

  return (
    <Tooltip title={t('excell.export')}>
        <IconButton
            size="large"
            onClick={exportToExcel}>
            <SimCardDownloadTwoToneIcon
                fontSize="large"
                className="color color-medium-green"
            />
        </IconButton>
    </Tooltip>
  );
}

export default ExcelExport;